import publicRoutes from '@/router/publicRoutes';
import callbackRoutes from '@/router/callbackRoutes';
import authPublicRoutes from '@/router/publicAuthRoutes';

const adminPages = [
  'profile',
  'company',
  'admin',
  'users',
  'callback',
  'acceptInvite',
  'personal-infos',
];

export const pagesChecker = {
  methods: {
    checkOauthNotAuthenticated(route) {
      if (authPublicRoutes.includes(route)) {
        return true;
      }
      return false;
    },
    checkCallbackPages(route) {
      if (callbackRoutes.includes(route)) {
        return true;
      }
      return false;
    },
    checkNotAuthenticatedPages(route) {
      if (publicRoutes.includes(route)) {
        return true;
      }
      return false;
    },
    checkNotAdminPages(route) {
      if (adminPages.includes(route)) {
        return true;
      }
      return false;
    },
    checkNotAdminAndNotAuthenticatedPages(route) {
      if (
        this.checkNotAdminPages(route) ||
        this.checkNotAuthenticatedPages(route)
      ) {
        return true;
      }
      return false;
    },
  },
};

export default {pagesChecker};
